import { render, staticRenderFns } from "./SeedDropdown.vue?vue&type=template&id=4c713d86&scoped=true"
import script from "./SeedDropdown.vue?vue&type=script&lang=ts"
export * from "./SeedDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c713d86",
  null
  
)

export default component.exports